import React from "react";

const COLORS: Record<string, string> = {
  pending_payment:  "#9ca3af",
  confirmed:        "#16a34a",
  pending_approval: "#d97706",
  declined:         "#dc2626",
  cancelled:        "#9ca3af",
  completed:        "#2563EB",
};

export default function StatusBadge({ status }: { status: string }) {
  const bg = COLORS[status] ?? "#6b7280";
  const label = status.replace(/_/g, " ");
  return (
    <span style={{
      fontSize: 12, padding: "2px 8px", borderRadius: 12,
      background: bg, color: "#fff", whiteSpace: "nowrap",
    }}>
      {label}
    </span>
  );
}
